import React from 'react'
import {
  CardContent,
  CardHeader,
  TableCell,
  TableContainer,
  TableHead,
  Card,
  Table,
  TableBody,
  TableRow,
} from '@material-ui/core'

interface StatsTableProps {
  title?: string
  titles: string[]
  values: number[]
}

export const StatsTable = ({ title, titles, values }: StatsTableProps) => {
  return (
    <Card>
      {title && (
        <CardHeader title={title} />
      )}
      <CardContent>
        <TableContainer>
          <Table aria-labelledby="tableTitle" size="small" aria-label="enhanced table">
            <TableHead>
              <TableRow>
                {titles.map((title) => (
                  <TableCell key={title} align="right">
                    {title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                {values.map((value, index) => (
                  <TableCell key={index} align="right">
                    {value.toLocaleString()}
                  </TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  )
}
